import axios from "axios";
import { sendMonitoringEvent } from "./accessMonitoringActivity";

export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    res => res,
    err => {
      if (err.response?.data?.reason === "FORCE_LOGOUT_22") {
        sendMonitoringEvent("logout");
        localStorage.clear();
        alert("Sistemi është përditësuar. Ju lutemi kyçuni përsëri.");
        window.location.href = "/";
      }
      return Promise.reject(err);
    }
  );
}
